/* Private Collector photos. Account-scoped requests; never public catalog evidence. */
(function (root, factory) {
  'use strict';
  if (typeof module === 'object' && module.exports) module.exports = {createPhotos: factory};
  else if (!root.MMCollectorPhotos) root.MMCollectorPhotos = factory(root);
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';
  const PROJECT = 'https://pnlenowzewtmwoyasxbq.supabase.co';
  const KEY = 'sb_publishable_MF16GLFsaKp-6p2ivHMJlg_fQ6VEoD4';
  const BUCKET = 'collector-photos', MAX = 8, MAX_BYTES = 15 * 1024 * 1024;
  const TYPES = {'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp'};
  const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const SESSION_KEYS = ['mmcc-session', 'mm-collector-cloud-session'];
  const cache = new Map(), pendingSigns = new Map(), controllers = new Set();
  const mounted = new Map(), uploadJobs = new Map(), completedUploads = new Map();
  const UPLOAD_PREFIX = 'mm-collector-photo-upload-v2:';
  let generation = 0, pendingUser = null, observed = null, interval = null;
  function fail(code, message) { return Object.assign(new Error(message), {code}); }
  function session() {
    for (const key of SESSION_KEYS) {
      let raw, value;
      try { raw = root.localStorage.getItem(key); value = JSON.parse(raw || 'null'); }
      catch (_) { return null; }
      if (value === null) continue;
      if (!value || typeof value.access_token !== 'string' || !/^[A-Za-z0-9._~-]{21,16383}$/.test(value.access_token)) return null;
      if (value.expires_at != null && (!Number.isFinite(Number(value.expires_at)) || Number(value.expires_at) <= Date.now() / 1000)) return null;
      return value;
    }
    return null;
  }
  function token() { return session()?.access_token || null; }
  function invalidate() {
    generation++; cache.clear(); pendingSigns.clear(); pendingUser = null; completedUploads.clear();
    controllers.forEach(controller => controller.abort()); controllers.clear();
    for (const [container, view] of mounted) {
      view.version++;
      container.querySelectorAll?.('img').forEach(image => image.removeAttribute('src'));
      container.replaceChildren();
      if (container.isConnected === false) { mounted.delete(container); continue; }
      const message = root.document?.createElement('p');
      if (message) { message.className = 'mm-engine-muted'; message.textContent = 'Private photos are hidden. Reopen this item after confirming your account.'; container.appendChild(message); }
    }
  }
  function reconcile() {
    const current = token();
    if (current !== observed) { observed = current; invalidate(); }
  }
  function assertCurrent(auth) {
    if (auth.generation !== generation || token() !== auth.token) {
      throw fail('PHOTO_ACCOUNT_CHANGED', 'Your Collector account changed. No further photo changes were sent. Reopen the item with the correct account.');
    }
  }
  function headers(accessToken, extra) { return Object.assign({apikey: KEY, Authorization: 'Bearer ' + accessToken}, extra || {}); }
  async function request(path, auth, options = {}, acceptMissing = false) {
    assertCurrent(auth);
    const controller = new AbortController(); controllers.add(controller);
    const timeout = root.setTimeout(() => controller.abort(), 15000);
    try {
      const response = await root.fetch(PROJECT + path, Object.assign({}, options, {
        cache: 'no-store', credentials: 'omit', signal: controller.signal,
        headers: headers(auth.token, options.headers)
      }));
      assertCurrent(auth);
      const data = await response.json().catch(() => null);
      assertCurrent(auth);
      if (!response.ok && !(acceptMissing && response.status === 404)) {
        throw fail(response.status === 401 || response.status === 403 ? 'PHOTO_ACCESS_DENIED' : 'PHOTO_REQUEST_FAILED',
          response.status === 401 || response.status === 403 ? 'Your private photo request was not authorized. Check your Collector sign-in.' : 'The private photo request could not be confirmed. Your other saved records are unchanged.');
      }
      return {status: response.status, data};
    } catch (error) {
      assertCurrent(auth);
      if (error.code) throw error;
      throw fail('PHOTO_REQUEST_UNCONFIRMED', 'The photo request did not finish. Its result is unconfirmed; check the item before trying again.');
    } finally { root.clearTimeout(timeout); controllers.delete(controller); }
  }
  async function user() {
    reconcile(); const accessToken = token();
    if (!accessToken) throw fail('PHOTO_SIGN_IN_REQUIRED', 'Sign in to your Collector account to view or change private photos.');
    if (pendingUser && pendingUser.token === accessToken && pendingUser.generation === generation) return pendingUser.promise;
    const auth = {token: accessToken, generation};
    const pending = {token: accessToken, generation, promise: null};
    pending.promise = (async () => {
      const {data} = await request('/auth/v1/user', auth);
      if (!data || !UUID.test(String(data.id || '')) || data.is_anonymous === true || !data.email_confirmed_at) {
        throw fail('PHOTO_SIGN_IN_REQUIRED', 'A confirmed Collector account is required for private photos.');
      }
      assertCurrent(auth); return Object.assign(auth, {id: String(data.id).toLowerCase()});
    })().finally(() => { if (pendingUser === pending) pendingUser = null; });
    pendingUser = pending; return pending.promise;
  }
  function cleanRecordId(value) {
    if (typeof value !== 'string' || !value || value.length > 220 || ['__proto__', 'constructor', 'prototype', '__default__'].includes(value)) {
      throw fail('PHOTO_INVALID_RECORD', 'Open a saved collection item before adding photos.');
    }
    const clean = value.replace(/[^a-zA-Z0-9_.:@-]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 180);
    if (!clean || clean === '.' || clean === '..') throw fail('PHOTO_INVALID_RECORD', 'The photo record identity is invalid.');
    return clean;
  }
  function validPath(path, uid) {
    return typeof path === 'string' && path.length <= 500 && path.startsWith(uid + '/') &&
      /^[0-9a-f-]{36}\/[a-zA-Z0-9_.:@/-]+$/i.test(path) && !path.includes('..') &&
      path.split('/').length === 3 && /\.(jpg|jpeg|png|webp)$/i.test(path);
  }
  function requirePath(path, auth) {
    if (!validPath(path, auth.id)) throw fail('PHOTO_WRONG_OWNER', 'This private photo does not belong to the signed-in Collector account.');
  }
  function objectPath(path) { return path.split('/').map(encodeURIComponent).join('/'); }
  function validateFile(file) {
    if (!file || !Object.hasOwn(TYPES, file.type)) throw fail('PHOTO_INVALID_FILE', 'Choose a JPG, PNG, or WEBP photo.');
    if (!Number.isSafeInteger(file.size) || file.size < 1 || file.size > MAX_BYTES) throw fail('PHOTO_INVALID_FILE', 'Each collector photo must be 15 MB or smaller.');
    return file;
  }
  async function vaultPost(route, body, auth) {
    const {data} = await request('/functions/v1/collector-member-vault/' + route, auth,
      {method: 'POST', headers: {'content-type': 'application/json'}, body: JSON.stringify(body)});
    if (!data || data.ok === false || data.error) throw fail('PHOTO_LINK_UNCONFIRMED', 'The photo link could not be confirmed. Check the item before trying again.');
    return data;
  }
  async function removeWithAuth(path, recordId, auth) {
    assertCurrent(auth); requirePath(path, auth);
    if (recordId) {
      cleanRecordId(recordId);
      const result = await vaultPost('engine-photo-remove', {record_id: recordId, storage_path: path}, auth);
      if (result.linked === true) { cache.delete(path); return true; }
      if (result.linked !== false) throw fail('PHOTO_REMOVE_UNCONFIRMED', 'Photo removal was not confirmed. The stored photo has been kept.');
    }
    // Storage's remove endpoint accepts an owner-scoped list of object prefixes.
    await request('/storage/v1/object/' + BUCKET, auth, {method: 'DELETE',
      headers: {'content-type': 'application/json'}, body: JSON.stringify({prefixes: [path]})}, true);
    cache.delete(path); return true;
  }
  function batchKey(auth, recordId) { return UPLOAD_PREFIX + auth.id + ':' + encodeURIComponent(recordId); }
  function readBatch(auth, recordId) {
    let batch;
    try { batch = JSON.parse(root.localStorage.getItem(batchKey(auth, recordId)) || 'null'); }
    catch (_) { throw fail('PHOTO_RECOVERY_STORAGE', 'Upload recovery storage is unreadable. Keep your files and check browser storage before uploading.'); }
    if (batch === null) return null;
    const prefix = auth.id + '/' + cleanRecordId(recordId) + '/';
    if (batch?.version !== 2 || batch.owner !== auth.id || batch.recordId !== recordId ||
        !['engine','specimen'].includes(batch.target) || !Array.isArray(batch.entries) ||
        !batch.entries.length || batch.entries.length > MAX ||
        new Set(batch.entries.map(e => e?.path)).size !== batch.entries.length ||
        batch.entries.some(e => !e || !validPath(e.path,auth.id) || !e.path.startsWith(prefix) ||
          !/^[0-9a-f]{64}$/.test(e.digest || '') || !Object.hasOwn(TYPES,e.type) ||
          !Number.isSafeInteger(e.size) || e.size < 1 || e.size > MAX_BYTES || typeof e.started !== 'boolean')) {
      throw fail('PHOTO_RECOVERY_INVALID', 'This upload recovery record could not be validated. Nothing was uploaded or deleted.');
    }
    return batch;
  }
  function writeBatch(auth, batch) {
    assertCurrent(auth);
    try { root.localStorage.setItem(batchKey(auth,batch.recordId),JSON.stringify(batch)); }
    catch (_) { throw fail('PHOTO_RECOVERY_STORAGE', 'Upload recovery could not be saved on this device. No further uploads were sent.'); }
  }
  async function digest(bytes) {
    if (!root.crypto?.subtle?.digest) throw fail('PHOTO_BROWSER_REQUIRED', 'Use a current secure browser to recover and upload private photos.');
    return Array.from(new Uint8Array(await root.crypto.subtle.digest('SHA-256',bytes)),b => b.toString(16).padStart(2,'0')).join('');
  }
  async function hasUploadedBytes(entry, auth) {
    assertCurrent(auth);requirePath(entry.path,auth);
    const controller=new AbortController();controllers.add(controller);
    const timer=root.setTimeout(()=>controller.abort(),15000);
    try {
      const response=await root.fetch(PROJECT+'/storage/v1/object/authenticated/'+BUCKET+'/'+objectPath(entry.path),{
        method:'GET',credentials:'omit',cache:'no-store',signal:controller.signal,headers:headers(auth.token)
      });
      assertCurrent(auth);
      if(response.status===404)return false;
      if(!response.ok)throw fail('PHOTO_RECOVERY_UNCONFIRMED','The earlier upload could not be checked. No replacement upload or deletion was sent.');
      const size=Number(response.headers?.get?.('content-length'));
      if(Number.isFinite(size)&&size>MAX_BYTES)throw fail('PHOTO_RECOVERY_INVALID','The earlier upload exceeds the photo limit.');
      const bytes=await response.arrayBuffer();assertCurrent(auth);
      if(bytes.byteLength!==entry.size||await digest(bytes)!==entry.digest)throw fail('PHOTO_RECOVERY_INVALID','The stored file does not match the selected photo. Nothing was overwritten.');
      assertCurrent(auth);return true;
    }catch(error){assertCurrent(auth);if(error.code)throw error;throw fail('PHOTO_RECOVERY_UNCONFIRMED','The earlier upload could not be checked. Keep the same files and retry when your connection returns.');}
    finally{root.clearTimeout(timer);controllers.delete(controller);}
  }
  async function attachEntry(batch,entry,index,auth) {
    let receipt;
    if(batch.target==='specimen'){
      receipt=await vaultPost('specimen-photo-attach',{specimen_id:batch.recordId,storage_path:entry.path,angle:null,is_primary:batch.existingCount===0&&index===0},auth);
      if(receipt.specimen_id!==batch.recordId||!UUID.test(String(receipt.photo_id||'')))throw fail('PHOTO_LINK_UNCONFIRMED','The server did not confirm this photo attachment. Its file was kept private.');
    }else{
      receipt=await vaultPost('engine-photo-attach',{record_id:batch.recordId,storage_path:entry.path},auth);
      if(receipt.linked!==true&&!(receipt.linked===false&&receipt.reason==='specimen_not_projected'))throw fail('PHOTO_LINK_UNCONFIRMED','The uploaded file is private, but its collection link was not confirmed. Retry with the same files.');
    }
    assertCurrent(auth);entry.confirmed=true;writeBatch(auth,batch);
  }
  async function lockedUpload(recordId, run) {
    // One browser-origin lock coordinates tabs. Unsupported browsers fail before writes.
    if(!root.navigator?.locks?.request)throw fail('PHOTO_BROWSER_REQUIRED','This browser cannot safely coordinate photo uploads. Use a current browser with Web Locks support.');
    if(uploadJobs.has(recordId))throw fail('PHOTO_UPLOAD_BUSY','A photo upload for this copy is already running.');
    const job=root.navigator.locks.request('mm-collector-photo:'+recordId,{mode:'exclusive',ifAvailable:true},lock=>{
      if(!lock)throw fail('PHOTO_UPLOAD_BUSY','Another tab is uploading photos for this copy. Finish that request first.');
      return run();
    });
    uploadJobs.set(recordId,job);
    try{return await job;}finally{if(uploadJobs.get(recordId)===job)uploadJobs.delete(recordId);}
  }
  async function upload(recordId, files, existingCount = 0, options = {}) {
    const cleanId=cleanRecordId(recordId),list=Array.from(files||[]).map(validateFile),target=options.target||'engine';
    if(!['engine','specimen'].includes(target)||(target==='specimen'&&!UUID.test(recordId)))throw fail('PHOTO_INVALID_RECORD','Choose the correct saved physical copy before uploading.');
    if(!Number.isSafeInteger(existingCount)||existingCount<0||existingCount>MAX||list.length>MAX)throw fail('PHOTO_LIMIT','A collection item can have up to '+MAX+' private photos.');
    if(!list.length)return [];
    const auth=await user();
    return lockedUpload(recordId,async()=>{
      assertCurrent(auth);
      const fingerprints=[];
      for(const file of list){const bytes=await file.arrayBuffer();assertCurrent(auth);fingerprints.push({digest:await digest(bytes),size:file.size,type:file.type});}
      const signature=JSON.stringify(fingerprints),prior=readBatch(auth,recordId);
      let batch=prior;
      if(prior&&(prior.signature!==signature||prior.target!==target)&&prior.complete!==true)throw fail('PHOTO_PENDING_UPLOAD','An earlier upload is still unconfirmed. Select those same files again or use Recover interrupted upload before adding different photos.');
      if(!prior||prior.signature!==signature||prior.target!==target){
        if(existingCount+list.length>MAX)throw fail('PHOTO_LIMIT','A collection item can have up to '+MAX+' private photos.');
        if(!root.crypto?.randomUUID)throw fail('PHOTO_BROWSER_REQUIRED','Secure photo identifiers are unavailable.');
        batch={version:2,owner:auth.id,recordId,target,existingCount,signature,complete:false,createdAt:new Date().toISOString(),entries:fingerprints.map(f=>({...f,path:auth.id+'/'+cleanId+'/'+root.crypto.randomUUID()+'.'+TYPES[f.type],started:false,confirmed:false}))};
        writeBatch(auth,batch);
      }
      try{
        for(let i=0;i<batch.entries.length;i++){
          const entry=batch.entries[i];assertCurrent(auth);
          const exists=entry.started?await hasUploadedBytes(entry,auth):false;
          if(!exists){
            entry.started=true;writeBatch(auth,batch);
            try{await request('/storage/v1/object/'+BUCKET+'/'+objectPath(entry.path),auth,{method:'POST',headers:{'content-type':entry.type,'x-upsert':'false'},body:list[i]});}
            catch(error){
              // A late prior request may have committed. Confirm bytes, never overwrite.
              if(error.code==='PHOTO_ACCOUNT_CHANGED')throw error;
              if(!await hasUploadedBytes(entry,auth))throw error;
            }
            if(!await hasUploadedBytes(entry,auth))throw fail('PHOTO_UPLOAD_UNCONFIRMED','The uploaded file was not confirmed. Keep the same files for recovery.');
          }
          await attachEntry(batch,entry,i,auth);
        }
        batch.complete=true;writeBatch(auth,batch);assertCurrent(auth);completedUploads.set(recordId,{auth,batch});
        return batch.entries.map(entry=>entry.path);
      }catch(error){
        if(error.code!=='PHOTO_ACCOUNT_CHANGED')error.message+=' Files already uploaded were kept private. Select the same files again to recover this request.';
        // Never send automatic DELETE after an uncertain upload/attachment result.
        throw error;
      }
    });
  }
  async function recoverPending(recordId) {
    cleanRecordId(recordId);const auth=await user();
    return lockedUpload(recordId,async()=>{
      const batch=readBatch(auth,recordId);if(!batch)return [];
      for(let i=0;i<batch.entries.length;i++){
        const entry=batch.entries[i];assertCurrent(auth);
        if(!entry.started||!await hasUploadedBytes(entry,auth))throw fail('PHOTO_FILES_REQUIRED','Some original files have not reached storage. Select the same files again to finish this upload.');
        await attachEntry(batch,entry,i,auth);
      }
      batch.complete=true;writeBatch(auth,batch);completedUploads.set(recordId,{auth,batch});return batch.entries.map(entry=>entry.path);
    });
  }
  async function acknowledgeUploaded(recordId, paths) {
    const auth=await user(),batch=readBatch(auth,recordId);
    if(!batch||batch.complete!==true||!Array.isArray(paths)||!batch.entries.every(entry=>paths.includes(entry.path)))return false;
    assertCurrent(auth);root.localStorage.removeItem(batchKey(auth,recordId));completedUploads.delete(recordId);return true;
  }
  function acknowledgeEngineRecord() {
    const engine=root.MMCollectorEngine,member=root.MMCollectorMembership?.getState?.();
    if(!engine?.getRecords||!member?.accountVerified||engine.getHealth?.().readable===false)return;
    for(const [recordId,job]of completedUploads){
      if(job.batch.target!=='engine')continue;
      try{
        assertCurrent(job.auth);
        if(!engine.getOwnerScopeHash||member.ownerScopeHash!==engine.getOwnerScopeHash(job.auth.id))continue;
        const record=engine.getRecords().find(row=>row.recordId===recordId),batch=readBatch(job.auth,recordId);
        if(batch?.complete===true&&batch.signature===job.batch.signature&&Array.isArray(record?.photoPaths)&&batch.entries.every(entry=>record.photoPaths.includes(entry.path))){
          root.localStorage.removeItem(batchKey(job.auth,recordId));completedUploads.delete(recordId);
        }
      }catch(_){ /* A retained receipt is safer than discarding unconfirmed local recovery. */ }
    }
  }
  function signedAddress(raw, path) {
    if (typeof raw !== 'string' || !raw || raw.length > 16000) throw fail('PHOTO_URL_INVALID', 'The private photo address was not returned.');
    let absolute;
    if (/^https:\/\//.test(raw)) absolute = raw;
    else if (raw.startsWith('/storage/v1/')) absolute = PROJECT + raw;
    else if (raw.startsWith('/object/')) absolute = PROJECT + '/storage/v1' + raw;
    else if (raw.startsWith('object/')) absolute = PROJECT + '/storage/v1/' + raw;
    else throw fail('PHOTO_URL_INVALID', 'The private photo address could not be validated.');
    let url, pathname;
    try { url = new URL(absolute); pathname = decodeURIComponent(url.pathname); }
    catch (_) { throw fail('PHOTO_URL_INVALID', 'The private photo address could not be validated.'); }
    if (url.origin !== PROJECT || url.username || url.password || url.hash ||
        pathname !== '/storage/v1/object/sign/' + BUCKET + '/' + path || !url.searchParams.get('token')) {
      throw fail('PHOTO_URL_INVALID', 'The private photo address does not match this account and photo.');
    }
    return url.href;
  }
  async function signedURL(path) {
    const auth = await user(); requirePath(path, auth); assertCurrent(auth);
    const hit = cache.get(path);
    if (hit && hit.token === auth.token && hit.generation === generation && hit.expires > Date.now() + 30000) return hit.url;
    const pending = pendingSigns.get(path);
    if (pending && pending.token === auth.token && pending.generation === generation) return pending.promise;
    const entry = {token: auth.token, generation, promise: null};
    entry.promise = (async () => {
      const {data} = await request('/storage/v1/object/sign/' + BUCKET + '/' + objectPath(path), auth,
        {method: 'POST', headers: {'content-type': 'application/json'}, body: JSON.stringify({expiresIn: 300})});
      const url = signedAddress(data?.signedURL || data?.signedUrl, path);
      assertCurrent(auth); cache.set(path, {url, token: auth.token, generation, expires: Date.now() + 270000}); return url;
    })().finally(() => { if (pendingSigns.get(path) === entry) pendingSigns.delete(path); });
    pendingSigns.set(path, entry); return entry.promise;
  }
  async function remove(path, recordId) { const auth = await user(); return removeWithAuth(path, recordId, auth); }
  async function render(container, paths, onRemove, options) {
    if (!container || !root.document) return;
    reconcile();
    for (const element of mounted.keys()) if (element.isConnected === false) mounted.delete(element);
    const previous = mounted.get(container), view = {version: (previous?.version || 0) + 1};
    mounted.set(container, view); const renderGeneration = generation, accessToken = token(), version = view.version;
    container.querySelectorAll?.('img').forEach(image => image.removeAttribute('src'));
    container.replaceChildren(); const list = Array.isArray(paths) ? paths.slice(0, MAX) : [];
    if (!list.length) {
      if (options?.emptyText) { const p = root.document.createElement('p'); p.className = 'mm-engine-muted'; p.textContent = options.emptyText; container.appendChild(p); }
      return;
    }
    const active = () => mounted.get(container) === view && view.version === version && generation === renderGeneration && token() === accessToken && container.isConnected !== false;
    const jobs = list.map(async path => {
      // Per-card lexical bindings prevent late responses from painting the last card.
      const card = root.document.createElement('figure'), image = root.document.createElement('img');
      card.className = 'mm-collector-photo'; image.alt = 'Private collector photo'; image.loading = 'lazy'; image.decoding = 'async'; image.referrerPolicy = 'no-referrer';
      card.appendChild(image); container.appendChild(card);
      image.addEventListener('error', () => {
        if (!active()) return;
        image.removeAttribute('src'); image.alt = 'Private photo unavailable'; card.classList.add('is-error');
        if (!card.querySelector('figcaption')) { const caption = root.document.createElement('figcaption'); caption.textContent = 'This photo could not load. Reopen the item to retry.'; card.appendChild(caption); }
        cache.delete(path);
      });
      if (typeof onRemove === 'function') {
        const button = root.document.createElement('button'); button.type = 'button'; button.className = 'mm-collector-photo-remove';
        button.textContent = 'Remove'; button.setAttribute('aria-label', 'Remove this private collector photo');
        button.addEventListener('click', () => { if (active()) onRemove(path); }); card.appendChild(button);
      }
      try { const url = await signedURL(path); if (active()) image.src = url; }
      catch (_) {
        if (!active()) return;
        card.classList.add('is-error'); image.removeAttribute('src'); image.alt = 'Private photo unavailable';
        const caption = root.document.createElement('figcaption'); caption.textContent = accessToken ? 'Photo unavailable. Reopen the item to retry.' : 'Sign in to view this private photo.'; card.appendChild(caption);
      }
    });
    await Promise.all(jobs);
  }
  const onStorage = event => { if (event.key === null || SESSION_KEYS.includes(event.key)) reconcile(); };
  const stop = () => { invalidate(); if (interval !== null) root.clearInterval(interval); interval = null; };
  const start = () => { observed = token(); if (root.document && interval === null) interval = root.setInterval(reconcile, 1000); };
  const onShow = event => { if (event.persisted) start(); };
  root.addEventListener?.('mm:collector-engine-changed', acknowledgeEngineRecord);
  root.addEventListener?.('storage', onStorage); root.addEventListener?.('mm:membership-change', reconcile);
  root.addEventListener?.('focus', reconcile); root.addEventListener?.('pagehide', stop); root.addEventListener?.('pageshow', onShow);
  root.document?.addEventListener('visibilitychange', reconcile); start();
  function dispose() {
    stop(); mounted.clear(); root.removeEventListener?.('mm:collector-engine-changed', acknowledgeEngineRecord); root.removeEventListener?.('storage', onStorage); root.removeEventListener?.('mm:membership-change', reconcile);
    root.removeEventListener?.('focus', reconcile); root.removeEventListener?.('pagehide', stop); root.removeEventListener?.('pageshow', onShow);
    root.document?.removeEventListener('visibilitychange', reconcile);
  }
  return {version: '2026-10-14.3', upload, recoverPending, acknowledgeUploaded, remove, signedURL, render, maxPhotos: MAX, maxBytes: MAX_BYTES, invalidate, dispose};
});
